import { CircularProgress, Typography } from "@material-ui/core";
import LinearProgress from "@mui/material/LinearProgress";
import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import {
  useCreatePaymentOrder,
  useGetTransaction,
  getPaymentCreationErrorMessage,
} from "../../../api/payment/hooks";
import { LoadingModal } from "../../../components";
import { getTerminalId } from "../../../services";
import { useAutomaticOrderReceipt } from "../../../hooks/usePrinter";
import { useStore } from "../../../store";
import {
  CreatePaymentOrder,
  CreatePaymentOrderResponse,
  PaymentMethod,
} from "../../../types";
import { getPaymentMethodName } from "../../../utils/getPaymentMethodName";
import useStyles from "./styles";
import { createCheckoutIdempotencyKey } from "../../../utils/createCheckoutIdempotencyKey";

export const TotemTerminalPayment: React.FC = () => {
  const checkoutIdempotencyKey = useRef(createCheckoutIdempotencyKey());
  const Styles = useStyles();
  const {
    userManager, navigation, order, userTotem
  } = useStore();
  const {
    state: { paymentMethod },
  }: {
    state: {
      paymentMethod?: PaymentMethod;
    };
  } = useLocation();
  const [transactionId, setTransactionId] = useState<string>("");
  const [modalMessage, setModalMessage] = useState<string>("");
  const [seconds, setSeconds] = useState(300);
  const [isActive, setIsActive] = useState(false);
  const [reTryPaymentCall, setReTryPaymentCall] = useState(false);
  const [showBtn, setShowBtn] = useState(false);
  const [showRetryBtn, setShowRetryBtn] = useState(false);
  const [creationError, setCreationError] = useState(false);
  const { data: transaction } = useGetTransaction(
    transactionId,
    !!transactionId,
    isActive && seconds > 0,
  );
  useAutomaticOrderReceipt(transaction?.status === "3", transactionId, {
    clientName: userTotem.name || order.clientName || "Cliente",
    totalAmount: order.totalAmount,
    items: order.items,
  });
  const { mutateAsync: mutatePaymentOrder, isLoading: paymentOrderLoading } =
    useCreatePaymentOrder();

  const stopTimer = () => {
    setIsActive(false);
  };

  useEffect(() => {
    (async () => {
      if (transaction) {
        if (transaction.status === "3") {
          setIsActive(false);

          order.reset();

          setModalMessage("Compra Finalizada");

          setTimeout(() => {
            navigation.navigateTo("/market-home");

            setModalMessage("");
          }, 3000);
        }
        if (transaction.status !== "1" && transaction.status !== "3") {
          setIsActive(false);

          setShowBtn(true);
          setShowRetryBtn(true);
          setModalMessage("Não foi possível confirmar o pagamento. Verifique a máquina antes de tentar novamente.");
        }
      }
    })();
  }, [transaction]);

  useEffect(() => {
    (async () => {
      if (transaction) {
        if (transaction.status === "3") {
          stopTimer();
        }
        if (transaction.status !== "3" && seconds === 0) {
          stopTimer();
        }
      }
    })();
  }, [transaction, seconds]);

  useEffect(() => {
    (async () => {
      try {
        const Payload: CreatePaymentOrder = {
          checkoutIdempotencyKey: checkoutIdempotencyKey.current,
          amount: order.totalAmount,
          entityId: userManager.entity,
          clientName: userTotem.name || order.clientName || "Cliente",
          terminalId: getTerminalId() ?? "",
          reference: "MenuPass",
          application: "MenuPass",
          paymentMethod: Number(paymentMethod),
          isSelfCheckoutTotem: true,
          virtualCardId: userTotem.virtualCard?.id,
          items: order.items.map((item) => {
            const {
              id, name, amount, price, totalAmount
            } = item;

            return {
              id,
              name,
              quantity: amount,
              price,
              totalAmount,
            };
          }),
        };
        const response: CreatePaymentOrderResponse = await mutatePaymentOrder(
          Payload
        );
        if (response?.id) {
          setTransactionId(response?.id);
          setIsActive(true);
          setSeconds(300);
          return;
        }
        console.log("error", 1);
        setModalMessage("Não foi possível confirmar o pagamento. Verifique a máquina antes de tentar novamente.");
        order.reset();
        setShowBtn(true);
      } catch (error) {
        setIsActive(false);
        setTransactionId("");
        setCreationError(true);
        setShowBtn(true);
        setShowRetryBtn(false);
        setModalMessage(getPaymentCreationErrorMessage(error));
      }
    })();
  }, [reTryPaymentCall]);

  const handleClose = () => {
    if (creationError) {
      navigation.navigateTo("/market-purchase");
      setModalMessage("");
      return;
    }
    order.reset();
    navigation.navigateTo("/market-home");
    setModalMessage("");
  };

  const handleRetry = () => {
    setModalMessage("");
    setReTryPaymentCall(!reTryPaymentCall);
  };

  if (
    paymentMethod === PaymentMethod.CREDIT_CARD ||
    paymentMethod === PaymentMethod.DEBIT_CARD
  ) {
    return (
      <div className={Styles.container}>
        <div className={Styles.containerRelative}>
          <div className={Styles.formView}>
            <Typography className={Styles.title}>
              {`Pagamento ${getPaymentMethodName(paymentMethod)} - ${userTotem.name || order.clientName || "Cliente"}`}
            </Typography>

            <div className={Styles.PixContainer}>
              {paymentOrderLoading ? (
                <CircularProgress />
              ) : (
                <div>
                  <Typography className={Styles.subTitle}>
                    Aguardando Pagamento
                  </Typography>
                  <LinearProgress color="primary" />
                </div>
              )}
            </div>

            <Typography className={Styles.subTitle}>
              Pague na máquina de cartão
            </Typography>

            <div className={Styles.actions}>
              <Typography className={Styles.subTitle}>
                Para cancelar a compra, por favor realize o processo na máquina
              </Typography>
            </div>
          </div>

          <LoadingModal
            open={!!modalMessage}
            message={modalMessage}
            showButton={showBtn}
            showRetryButton={showRetryBtn}
            onClick={() => handleClose()}
            onClickRetry={() => handleRetry()}
          />
        </div>
      </div>
    );
  }
  return <div />;
};
